import { MutationTree } from 'vuex'
import { SectionStateInterface } from 'src/store/section/state'
import { UserGroup } from 'able-lib'

const mutation: MutationTree<SectionStateInterface> = {
  SET_LEVELS_AND_SECTIONS (state: SectionStateInterface, levelsAndSections): void {
    state.levelsAndSections = levelsAndSections
  },

  SET_CURRENT_SECTION_USERS (state: SectionStateInterface, currentSectionUsers: Array<number>): void {
    state.currentSectionUsers = currentSectionUsers
  },

  SET_STUDENT_LIST (state: SectionStateInterface, students: Array<UserGroup>): void {
    state.students = students
  },

  SET_TEACHER_LIST (state: SectionStateInterface, teachers: Array<UserGroup>): void {
    state.teachers = teachers
  },

  SET_SELECTED_LEVEL (state: SectionStateInterface, selectedLevel): void {
    state.selectedLevel = selectedLevel
  }
}

export default mutation
